import React from 'react';

import styled from '@emotion/styled';

import { primaryColor, unit, unitTRBL, white } from '@zego/theme';

import H2 from '@zego/components/atoms/H2';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import Carousel from '@zego/components/molecules/Carousel';

import BrokerMicromobility from '@zego/static/svgs/BrokerMicromobility.svg';
import FleetCourier from '@zego/static/svgs/FleetCourier.svg';
import FleetPrivateHire from '@zego/static/svgs/FleetPrivateHire.svg';
import FleetTrades from '@zego/static/svgs/FleetTrades.svg';
import HaulageFleet from '@zego/static/svgs/HaulageFleet.svg';

const BROKER_COPY = [
  {
    id: 'fleet-private-hire',
    image: FleetPrivateHire,
    alt: 'Fleet private hire',
    title: 'Private-hire',
    description: 'Pre-booked\n10+ vehicles\nUp to 9 seats',
  },
  {
    id: 'fleet-courier',
    image: FleetCourier,
    alt: 'Fleet courier',
    title: 'Courier',
    description: 'Cars, vans and mopeds\n10+ vehicles\nUp to 3.5 tonnes',
  },
  {
    id: 'fleet-trades',
    image: FleetTrades,
    alt: 'Fleet trades',
    title: 'Trades',
    description: 'Cars, vans + HGV\n6+ vehicles\nUp to 44 tonnes',
  },
  {
    id: 'micro-mobility',
    image: BrokerMicromobility,
    alt: 'Micromobility',
    title: 'Micromobility',
    description: 'E-bikes and e-scooters\n300+ vehicles\n\n',
  },
  {
    id: 'haulage-fleet',
    image: HaulageFleet,
    alt: 'Haulage fleet',
    title: 'Haulage',
    description: 'COMING SOON\n\n\n',
  },
];

const Container = styled(View)({
  backgroundColor: primaryColor(9),
  color: white,
  padding: unitTRBL(8, 0, 8, 0),
});

const CentredHeading = styled(H2)({
  textAlign: 'center',
  color: white,
});

export default function BrokerWhoDoWeInsure(): JSX.Element {
  return (
    <Container>
      <CentredHeading>Who do we insure?</CentredHeading>
      <Spacer height={unit(6)} />
      <Carousel
        items={BROKER_COPY}
        dotColourActive={primaryColor(1)}
        dotColourDisabled={primaryColor(7)}
        showOverflowOnMobile={true}
        css={{ background: 'red' }}
      />
    </Container>
  );
}
